<div class="row justify-content-end" *appFeaturesAuth="{section:'BUTTON',identifier:'BUTTON.START_ENR'}">
  <button class="btn btn-primary btn-sm" [disabled]="isOutOfStock" id="enrollmentButton" (click)="initEnrollment()" *ngIf="this.isAccountSelected" >
    {{'BUTTON.START_ENR' | translate}} 
  </button>
</div>
